export function CalculatorSlider({
  label,
  value,
  min,
  max,
  step,
  formatValue,
  onChange,
}: {
  label: string
  value: number
  min: number
  max: number
  step: number
  formatValue: (v: number) => string
  onChange: (v: number) => void
}) {
  const percent = ((value - min) / (max - min)) * 100

  return (
    <div>
      <div className="flex items-baseline justify-between">
        <label className="text-sm font-medium text-charcoal">{label}</label>
        <span className="font-display text-lg font-bold text-charcoal">
          {formatValue(value)}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="mt-2 h-2 w-full cursor-pointer appearance-none rounded-full bg-stone accent-red"
        style={{
          background: `linear-gradient(to right, #C41E2A ${percent}%, #E8E4DF ${percent}%)`,
        }}
      />
      <div className="mt-1 flex justify-between text-[10px] text-warm-grey">
        <span>{formatValue(min)}</span>
        <span>{formatValue(max)}</span>
      </div>
    </div>
  )
}
